// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Lock type</td>
      <td>
        <select ng-model="\$ctrl.type"
                ng-options="lock.type as lock.label for lock in \$ctrl.lockTypes"
                ng-required="true">
        </select>
      </td>
    </tr>
    <tr>
      <td>Auto release</td>
      <td>
        <select
          required
          ng-model="\$ctrl.autoRelease"
          boolean-options>
        </select>
      </td>
    </tr>
    <tr ng-if="\$ctrl.autoRelease">
      <td>Auto release on</td>
      <td>
        <date ng-model="\$ctrl.autoReleasedOn"
              output-format="date"
              default-date-offset="1"
              ng-required="true"></date>
      </td>
    </tr>
    <tr>
      <td>Remarks</td>
      <td>
        <input
          required
          type="text"
          minlength="1"
          maxlength="128"
          ng-model="\$ctrl.remarks"/>
      </td>
    </tr>
    <tr>
      <td>Content:</td>
      <td>
        <file-upload
          ng-model="\$ctrl.contentFile"
          required
          validate-uploaded
          max-files="1"
          show-file-name="true"
          show-remarks="false"
          enable-webcam="false">
        </file-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download sample file
    </button>
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/batch-product-lock/batch-create-product-lock.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;